import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponseModel, ApiVisa, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { BaseGenDocTypeService } from './base-generic-doc-hdr.service';
import { GenericDocSearchCriteriaDtoModel } from '../../../data-transfer-objects';

@Injectable({ providedIn: 'root' })
export class InternalPurchaseInvoiceNoStockInService extends BaseGenDocTypeService {

  readonly url =
    Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-purchase-invoice-no-stock-in';

  constructor(http: HttpClient) {
    super(http, 'internal-purchase-invoice-no-stock-in');
  }

  public getBySnapshotCustomQueryLoginEntityEp(dtoObject: GenericDocSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/custom/query/snapshot/login-entity-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
  
  getLinesByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string): Observable<Blob> {
    let params;
    let url;
    if (customParam) {
      params = new HttpParams()
      .set('printServiceClassName', printServiceClassName)
      .set('printableFormatHdrGuid', printableFormatGuid)
      .set('customParam', customParam);
    } else {
      params = new HttpParams()
      .set('printServiceClassName', printServiceClassName)
      .set('printableFormatHdrGuid', printableFormatGuid);
    }
    url = apiVisa.api_domain_url + this.endpoint_path + '/print-jasper-pdf/' + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

}